(function () {
  function activate(rows, row) {
    rows.forEach(function (item) {
      item.classList.remove('is-active');
      item.classList.remove('active');
      item.setAttribute('aria-expanded', 'false');
    });
    row.classList.add('is-active');
    row.classList.add('active');
    row.setAttribute('aria-expanded', 'true');
  }

  function playVideos(root) {
    root.querySelectorAll('video').forEach(function (video) {
      if (video.dataset.rvrnBuildVideoReady === 'true') return;
      video.dataset.rvrnBuildVideoReady = 'true';
      video.addEventListener('loadedmetadata', function () {
        try {
          if (video.duration > 2) video.currentTime = 1.2;
        } catch (e) {}
        var play = video.play();
        if (play && play.catch) play.catch(function () {});
      }, { once: true });
    });
  }

  function init(scope) {
    var root = scope || document;
    root.querySelectorAll('[data-rvrn-build-system]').forEach(function (root) {
      var rows = Array.prototype.slice.call(root.querySelectorAll('[data-rvrn-system-row]'));
      rows.forEach(function (row) {
        if (row.dataset.rvrnBuildReady === 'true') return;
        row.dataset.rvrnBuildReady = 'true';
        row.addEventListener('mouseenter', function () {
          activate(rows, row);
        });
        row.addEventListener('touchstart', function () {
          activate(rows, row);
        }, { passive: true });
        row.addEventListener('click', function () {
          activate(rows, row);
        });
        row.addEventListener('focus', function () {
          activate(rows, row);
        });
      });
      playVideos(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
    if (window.RVRNReveal && window.RVRNReveal.init) {
      window.RVRNReveal.init(event.target);
    }
  });
})();
